module.exports = __webpack_public_path__ + "static/google-play-badge-zh-b729ec6e192c841f0e7c6dacdecabad5.png";